// extracted by mini-css-extract-plugin
export var header = "optomap-module--header--hyWcI";
export var image = "optomap-module--image--9EmPI";
export var imageWrapper = "optomap-module--imageWrapper--9BWIF";
export var optomapGrid = "optomap-module--optomapGrid--nriiI";
export var paragraph = "optomap-module--paragraph--Ul8+Y";
export var paragraphWrapper = "optomap-module--paragraphWrapper--t73a5";
export var wrapper = "optomap-module--wrapper--zcaDS";